import styled, { css } from 'styled-components';

export const Card = styled.button<{ $selected: boolean }>`
  position: relative;
  display: block;
  width: 100%;
  text-align: left;
  cursor: pointer;
  transition: border-color 200ms ease, background 200ms ease;

  /*
   * The only visual change on selection is the accent-coloured border + the
   * check badge in the corner — the surface fill stays the same. Hover is the
   * only state that tints the surface.
   */
  ${({ $selected, theme: { colors, spacing, borderRadius } }) => css`
    padding: ${spacing?.level6};
    border-radius: ${borderRadius?.large};
    border: 1px solid ${$selected ? colors?.primary : colors?.outlineVariant};
    background: ${colors?.surfaceContainerLow};
    color: ${colors?.onSurface};

    &:hover,
    &:focus-visible {
      border-color: ${$selected ? colors?.primary : colors?.outline};
      background: ${colors?.surfaceContainer};
      outline: none;
    }
  `}
`;

export const CheckBadge = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme: { spacing, colors } }) => css`
    top: ${spacing?.level4};
    right: ${spacing?.level4};
    background: ${colors?.primary};
    color: ${colors?.onPrimary};

    & > svg {
      width: 14px;
      height: 14px;
      fill: ${colors?.onPrimary};
    }
  `}
`;

export const Title = styled.div`
  /* 16px font-semibold — bodyLarge rather than titleSmall (14px). */
  ${({ theme: { font, spacing } }) => css`
    ${font?.bodyLarge}
    font-weight: 600;
    margin-bottom: ${spacing?.level2};
    padding-right: ${spacing?.level7};
  `}
`;

export const Description = styled.div`
  ${({ theme: { font, colors } }) => css`
    ${font?.bodySmall}
    color: ${colors?.onSurfaceVariant};
    line-height: 1.45;
  `}
`;
